export const vuetifyTheme = {
	primary: '#406A94',
	accent: '#406A94',
	secondary: '#1d647a',
	tertiary: '#7F8C98',
	'nav-icon-color': '#242529',
	success: '#39a275',
	background: '#f5f5f5',
	'main-accordion': '#0B3142',
	'syrenis-red': '#ed303e',
	'syrenis-black': '#242529',
	'syrenis-grey': '#f5f5f5',
	'steel-blue': '#406A94',
	'prussian-blue': '#0B3142',
	'cool-gray': '#7D8CA3',
	'battleship-gray': '#969A97',
	'black-olive': '#334139',
	'cadet-gray': '#7F8C98',
	onyx: '#3C3C3C',
	'muted-teal': '#5a8780'
}

export const vuetifyThemeDark = {
	primary: '#ed303e',
	accent: '#ed303e',
	secondary: '#2d8aa0',
	tertiary: '#9faab6',
	'nav-icon-color': '#e5e5e5',
	success: '#22c55e',
	background: '#121214', // Neutral grey - aligned with --global-main-background-color
	'main-accordion': '#1c1c1e',
	'syrenis-red': '#ed303e',
	'syrenis-black': '#f5f5f5',
	'syrenis-grey': '#18181a', // Neutral grey - aligned with --global-card-background area
	'steel-blue': '#5a8ab8',
	'prussian-blue': '#1c1c1e', // Neutral grey
	'cool-gray': '#9ca3ab', // Neutral grey - aligned with --global-muted-foreground
	'battleship-gray': '#a8aca9',
	'black-olive': '#8fa399',
	'cadet-gray': '#9ca3ab', // Neutral grey
	onyx: '#2a2a2a',
	'muted-teal': '#6fa8a0'
}

export const vuetifyThemeConfig = {
	light: vuetifyTheme,
	dark: vuetifyThemeDark
}
